/**
 * Warehouse Insights API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ColumnDef } from './columnDef';
import { DataSource } from './dataSource';


/**
 * A tabular block with typed columns and arbitrary row dictionaries. Each row\'s keys correspond to the `key` of a column definition.
 */
export interface DataTableBlock { 
    /**
     * Discriminator identifying this block as a data table.
     */
    type?: DataTableBlock.TypeEnum;
    /**
     * Optional heading shown above the table.
     */
    title?: string | null;
    /**
     * Optional sub-heading shown beneath the title, for example the analysis window or a short descriptor of what the rows represent. Omitted when there is nothing useful to add.
     */
    subtitle?: string | null;
    /**
     * Optional caption beneath the table for context, such as describing a reference value or data source. Omitted when there is nothing useful to add.
     */
    footnote?: string | null;
    /**
     * Optional provenance metadata describing where the table data came from.
     */
    dataSource?: DataSource | null;
    /**
     * Ordered column definitions describing each column\'s key, label, and format.
     */
    columns: Array<ColumnDef>;
    /**
     * The table rows. Each row is a mapping from a column `key` to that cell\'s value. Values may be scalars or nested objects (for example a Delta for a \'delta-badge\' column).
     */
    rows: Array<{ [key: string]: any; }>;
}
export namespace DataTableBlock {
    export const TypeEnum = {
        DataTable: 'data-table'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


